import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import ButtonA from '../components/typography/buttons/ButtonA'
import P2 from '../components/typography/paragraphs/P2'
import H3 from '../components/typography/headers/H3'
import InputHint from '../components/typography/InputHint'
import JustifyCenter from '../components/presentational/JustifyCenter'
import PasswordField from '../components/typography/PasswordField'
import TextButton from '../components/typography/buttons/TextButton'
import ErrorMessage from '../components/auth/ErrorMessage'
import AuthWrapper from '../components/auth/AuthWrapper'

import { resetPassword } from '../actions/resetpassword'

class ResetPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      password: ''
    }

    this.handlePasswordChangeBound = this.handlePasswordChange.bind(this)
    this.onResetPasswordClickBound = this.onResetPasswordClick.bind(this)
    this.shouldButtonBeDisabledBound = this.shouldButtonBeDisabled.bind(this)
    this.onReturnToLoginClickBound = this.onReturnToLoginClick.bind(this)
    this.onTryAgainClickBound = this.onTryAgainClick.bind(this)
    this.checkForSubmitBound = this.checkForSubmit.bind(this)
    this.handleFormSubmitBound = this.handleFormSubmit.bind(this)

    window.scrollTo(0, 0)
  }

  render() {
    const { isLoading, success, failure } = this.props
    return (
      <AuthWrapper>
        {!isLoading && !failure && !success && (
          <React.Fragment>
            <JustifyCenter>
              <H3 style={{ marginBottom: '35px' }}>Create a New Password</H3>
            </JustifyCenter>
            <form style={{ textAlign: 'left' }}>
              <PasswordField
                label="New Password"
                onChange={this.handlePasswordChangeBound}
                onKeyPress={this.checkForSubmitBound}
                style={{ marginBottom: '44px' }}
                tooltipId="password"
              />
              <InputHint
                style={{
                  position: 'relative',
                  bottom: '40px',
                  left: '13px',
                  textAlign: 'left'
                }}
              >
                Minimum 8 characters
              </InputHint>
              <JustifyCenter>
                <ButtonA
                  type="submit"
                  onClick={this.onResetPasswordClickBound}
                  disabled={this.shouldButtonBeDisabledBound()}
                  style={{ marginBottom: '26px', width: 'unset' }}
                >
                  Create Password
                </ButtonA>
              </JustifyCenter>
            </form>
            <TextButton
              style={{ marginTop: 'auto' }}
              onClick={this.onReturnToLoginClickBound}
              fontSize="13px"
            >
              Return to Login
            </TextButton>
          </React.Fragment>
        )}

        {!isLoading && !success && failure && (
          <React.Fragment>
            <JustifyCenter>
              <ErrorMessage style={{ marginBottom: '30px' }}>
                Password Change Unsuccessful
              </ErrorMessage>
              <P2 style={{ marginBottom: '53px' }}>
                Something went wrong. Please try changing your password again.
              </P2>
              <ButtonA
                style={{
                  padding: '0 21px',
                  marginBottom: '20px',
                  width: 'unset'
                }}
                onClick={this.onTryAgainClickBound}
              >
                Return to Forgot Password
              </ButtonA>
            </JustifyCenter>
            <TextButton
              style={{ marginTop: 'auto', width: 'unset' }}
              onClick={this.onReturnToLoginClickBound}
            >
              Return to Login
            </TextButton>
          </React.Fragment>
        )}
        {!isLoading && success && !failure && (
          <JustifyCenter>
            <H3 style={{ marginBottom: '35px' }}>Password Changed!</H3>
            <P2 style={{ marginBottom: '35px' }}>
              You can now use your new password to log in.
            </P2>
            <ButtonA
              style={{ marginBottom: '29px', width: 'unset' }}
              onClick={this.onReturnToLoginClickBound}
            >
              Return to Login
            </ButtonA>
          </JustifyCenter>
        )}
        {isLoading && (
          <div className="loading" style={{ minHeight: '250px' }} />
        )}
      </AuthWrapper>
    )
  }

  checkForSubmit(e) {
    if (
      !this.shouldButtonBeDisabled() &&
      (e.which === 13 || e.keyCode === 13)
    ) {
      this.onResetPasswordClick(e)
    }
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value.trim() })
  }

  shouldButtonBeDisabled() {
    return this.state.password.length < 8
  }

  onResetPasswordClick(e) {
    e.preventDefault()
    if (!this.shouldButtonBeDisabled()) {
      this.props.dispatch(
        resetPassword(this.props.params.token, this.state.password)
      )
    }
  }

  onReturnToLoginClick() {
    this.props.dispatch(push('/login'))
  }

  onTryAgainClick() {
    this.props.dispatch(push('/forgotpassword'))
  }

  handleFormSubmit(e) {
    e.preventDefault()
    return false
  }
}

export const mapStateToProps = state => ({
  isLoading: state.resetpassword.isLoading,
  failure: state.resetpassword.failure,
  success: state.resetpassword.success
})

ResetPassword.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  failure: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(ResetPassword)
export { ResetPassword as ResetPasswordDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js